import { useState } from "react";
import { Box, CircularProgress, Typography, Card } from "@mui/material";
import { LoadingButton } from "@mui/lab";
import Image from "next/image";
import MedicareInsuranceCard from "components/services/medicareInsuranceCard";

const MEDICARE_NAME = "MEDICARE";
export default function InsuranceList({
  onSubmit,
  onSelected,
  loading,
}: {
  // eslint-disable-next-line no-unused-vars
  onSubmit: (insurance: string) => void;
  // eslint-disable-next-line no-unused-vars
  onSelected: (insurance: string) => void;
  loading?: boolean;
}) {
  const [selected, setSelected] = useState<string | null>(null);
  const [showMedicare, setShowMedicare] = useState(false);

  const handleSelect = (payor: string) => {
    setSelected(payor);
    onSelected(payor);
  };

  const handleSubmit = async () => {
    if (selected === MEDICARE_NAME) {
      setShowMedicare(true);
    } else if (selected) {
      onSubmit(selected);
    }
  };

  const handleMedicareSubmit = async () => {
    if (selected) onSubmit(selected);
  };

  if (showMedicare)
    return (
      <MedicareInsuranceCard
        onSubmit={handleMedicareSubmit}
        loading={loading}
      />
    );

  return (
    <Box>
      <Typography
        variant="h1"
        align="center"
        sx={{
          fontFamily: "JazminAltLight",
          fontSize: "26px",
          lineHeight: "31.2px",
          letterSpacing: "-2%",
          marginTop: 1,
          color: "inherit",
          mt: 1,
          mb: 3,
        }}
      >
        Select your insurance provider
      </Typography>
      <Box
        sx={{
          width: {
            xs: "100%",
            sm: "600px",
          },
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Box
          sx={{
            display: "grid",
            gap: 1,
            alignItems: "center",
            justifyContent: "center",
            gridTemplateColumns: "repeat(2, 1fr)",
          }}
        >
          <Card
            elevation={0}
            onClick={() => handleSelect("BCBS")}
            sx={{
              padding: 0.5,
              border: 1,
              borderRadius: 1,
              width: 173,
              height: 54,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              borderColor: "#ADB8B8",
              background: selected !== "BCBS" ? "#fff" : "#D4DACF",
            }}
          >
            <Image
              src="/provider/bcbs.png"
              layout="intrinsic"
              alt="bcbs"
              width={100}
              height={45}
            />
          </Card>
          <Card
            elevation={0}
            onClick={() => handleSelect("AETNA")}
            sx={{
              padding: 0.5,
              border: 1,
              borderRadius: 1,
              width: 173,
              display: "flex",
              height: 54,
              alignItems: "center",
              justifyContent: "center",
              borderColor: "#ADB8B8",
              background: selected !== "AETNA" ? "#fff" : "#D4DACF",
            }}
          >
            <Image
              src="/provider/aetna.png"
              layout="intrinsic"
              alt="aetna"
              width={66}
              height={16}
            />
          </Card>
          <Card
            elevation={0}
            onClick={() => handleSelect("MEDICARE")}
            sx={{
              padding: 0.5,
              border: 1,
              borderRadius: 1,
              width: 173,
              background: selected !== "MEDICARE" ? "#fff" : "#D4DACF",
              display: "flex",
              height: 54,
              alignItems: "center",
              justifyContent: "center",
              borderColor: "#ADB8B8",
            }}
          >
            <Image
              src="/provider/medicare.png"
              layout="intrinsic"
              alt="medicare"
              width={131}
              height={44}
            />
          </Card>
          <Card
            elevation={0}
            onClick={() => handleSelect("UHC")}
            sx={{
              padding: 0.5,
              border: 1,
              borderRadius: 1,
              width: 173,
              display: "flex",
              height: 54,
              alignItems: "center",
              justifyContent: "center",
              borderColor: "#ADB8B8",
              background: selected !== "UHC" ? "#fff" : "#D4DACF",
            }}
          >
            <Image
              src="/provider/united.png"
              layout="intrinsic"
              alt="united"
              width={86}
              height={46}
            />
          </Card>
          <Card
            elevation={0}
            onClick={() => handleSelect("CIGNA")}
            sx={{
              padding: 0.5,
              border: 1,
              borderRadius: 1,
              width: 173,
              display: "flex",
              height: 54,
              alignItems: "center",
              justifyContent: "center",
              borderColor: "#ADB8B8",
              background: selected !== "CIGNA" ? "#fff" : "#D4DACF",
            }}
          >
            <Image
              src="/provider/cigna.png"
              layout="intrinsic"
              alt="cigna"
              width={61}
              height={45}
            />
          </Card>
          <Card
            elevation={0}
            onClick={() => handleSelect("HUMANA")}
            sx={{
              padding: 0.5,
              border: 1,
              borderRadius: 1,
              width: 173,
              display: "flex",
              height: 54,
              alignItems: "center",
              background: selected !== "HUMANA" ? "#fff" : "#D4DACF",
              justifyContent: "center",
              borderColor: "#ADB8B8",
            }}
          >
            <Image
              src="/provider/humana.png"
              layout="intrinsic"
              alt="humana"
              width={81}
              height={16}
            />
          </Card>
          <Card
            elevation={0}
            onClick={() => handleSelect("KAISER")}
            sx={{
              padding: 0.5,
              border: 1,
              borderRadius: 1,
              width: 173,
              display: "flex",
              height: 54,
              alignItems: "center",
              justifyContent: "center",
              background: selected !== "KAISER" ? "#fff" : "#D4DACF",
              borderColor: "#ADB8B8",
            }}
          >
            <Image
              src="/provider/kaiser.png"
              layout="intrinsic"
              alt="kaiser"
              width={102}
              height={31}
            />
          </Card>
          <Card
            elevation={0}
            onClick={() => handleSelect("AARP")}
            sx={{
              padding: 0.5,
              border: 1,
              borderRadius: 1,
              width: 173,
              display: "flex",
              height: 54,
              alignItems: "center",
              justifyContent: "center",
              background: selected !== "AARP" ? "#fff" : "#D4DACF",
              borderColor: "#ADB8B8",
            }}
          >
            <Image
              src="/provider/aarp.png"
              layout="intrinsic"
              alt="aarp"
              width={75}
              height={43}
            />
          </Card>
          {/* <Card */}
          {/*   elevation={0} */}
          {/*   onClick={() => handleSelect("MEDICAID")} */}
          {/*   sx={{ */}
          {/*     padding: 0.5, */}
          {/*     border: 1, */}
          {/*     borderRadius: 1, */}
          {/*     width: 173, */}
          {/*     display: "flex", */}
          {/*     height: 54, */}
          {/*     alignItems: "center", */}
          {/*     justifyContent: "center", */}
          {/*     background: selected !== "MEDICAID" ? "#fff" : "#D4DACF", */}
          {/*     borderColor: "#ADB8B8", */}
          {/*   }} */}
          {/* > */}
          {/*   <Image */}
          {/*     src="/provider/medicaid.png" */}
          {/*     layout="intrinsic" */}
          {/*     alt="medicaid" */}
          {/*     width={120} */}
          {/*     height={46} */}
          {/*   /> */}
          {/* </Card> */}
          <Card
            elevation={0}
            onClick={() => handleSelect("EMBLEM")}
            sx={{
              padding: 0.5,
              border: 1,
              borderRadius: 1,
              width: 173,
              display: "flex",
              height: 54,
              alignItems: "center",
              justifyContent: "center",
              background: selected !== "EMBLEM" ? "#fff" : "#D4DACF",
              borderColor: "#ADB8B8",
            }}
          >
            <Image
              src="/provider/emblem.png"
              layout="intrinsic"
              alt="united"
              width={121}
              height={35}
            />
          </Card>
          <Card
            elevation={0}
            onClick={() => handleSelect("OTHER")}
            sx={{
              padding: 0.5,
              border: 1,
              borderRadius: 1,
              width: 173,
              display: "flex",
              height: 54,
              alignItems: "center",
              justifyContent: "center",
              background: selected !== "OTHER" ? "#fff" : "#D4DACF",
              borderColor: "#ADB8B8",
            }}
          >
            <Typography align="center">Other*</Typography>
          </Card>
        </Box>
        <Typography align="center" sx={{ my: 2, fontSize: "14px" }}>
          * Your insurance information will be collected during intake. Please
          note, at this time we are only able to bill Medicaid in TN and CO.
          Those with Medicaid outside of these states would need to enroll in
          our cash pay option.
        </Typography>
      </Box>
      {loading && (
        <Box
          sx={{
            width: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: 1,
            my: 1,
            flexDirection: "column",
          }}
        >
          <CircularProgress />
          <Typography variant="caption" component="p" color="primary">
            Please wait...
          </Typography>
        </Box>
      )}
      {!loading && (
        <LoadingButton
          disabled={selected === null}
          variant="contained"
          onClick={handleSubmit}
          fullWidth
        >
          Confirm
        </LoadingButton>
      )}
    </Box>
  );
}
